import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getHppPaymentMethods } from 'services/HppSettingsService'

export const useHppPaymentMethodsQuery = () =>
  useQuery({
    queryKey: reactQueryKeys.hppPaymentMethods(),
    queryFn: getHppPaymentMethods,
  })
